import React from 'react'
import createIcon from '@/lib/create-icon'

export const ArrowUpRightIcon = createIcon(
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.16602 11.3332L11.8327 4.6665M11.8327 4.6665H5.16602M11.8327 4.6665V11.3332" stroke="currentColor" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,

)
